export default {"src":"/_next/static/media/vegetarian.30042296.svg","height":16,"width":16};